import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Students must accept the content-protection terms once per terms version.
const TermsGate = () => {
  const { user, logout } = useAuth();
  const [needed, setNeeded] = useState(false);
  const [agree, setAgree] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user || user.role !== 'student') {
      setNeeded(false);
      return;
    }
    axios
      .get(`${BACKEND_URL}/api/me/terms`, { withCredentials: true })
      .then(({ data }) => setNeeded(data.required && !data.accepted))
      .catch(() => setNeeded(false));
  }, [user]);

  if (!needed) return null;

  const accept = async () => {
    setSaving(true);
    try {
      await axios.post(`${BACKEND_URL}/api/me/terms/accept`, {}, { withCredentials: true });
      setNeeded(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/60 flex items-center justify-center p-4" data-testid="terms-gate">
      <div className="clay-card bg-white max-w-lg w-full p-8">
        <div className="flex items-center gap-3 mb-4">
          <ShieldCheck className="w-8 h-8 text-blue-600" />
          <h2 className="text-2xl font-outfit font-bold text-slate-900">Before you continue</h2>
        </div>
        <ul className="list-disc pl-5 space-y-2 font-figtree text-slate-700 text-sm mb-6">
          <li>Course videos and live lectures are for your personal learning only.</li>
          <li>Recording, screenshotting, downloading or sharing any lecture or course content is not allowed.</li>
          <li>Videos carry an AltanonLearn watermark. Do not copy, re-upload or share them.</li>
          <li>Your account can be used on one device at a time. Signing in elsewhere signs out the other device, and repeated sharing is reported.</li>
          <li>Suspicious actions such as screenshot keys or developer tools are logged and reviewed by the Altanon team, and can lead to your access being suspended.</li>
        </ul>
        <label className="flex items-start gap-3 font-figtree text-slate-800 mb-6 cursor-pointer">
          <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-1" data-testid="terms-checkbox" />
          <span>I have read and agree to these terms.</span>
        </label>
        <div className="flex gap-3">
          <Button className="clay-button-primary flex-1" disabled={!agree || saving} onClick={accept} data-testid="terms-accept-btn">
            Accept and continue
          </Button>
          <Button className="clay-button-secondary" onClick={async () => { await logout(); window.location.href = '/'; }}>
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermsGate;
